import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SimplizeLogo from "./SimplizeLogo";

export default function LegalNav() {
  const { pathname, search } = useLocation();
  const isMobile = new URLSearchParams(search).get("viewmode") === "mobile";

  useEffect(() => {
    const prev = {
      html: document.documentElement.style.overflow,
      body: document.body.style.overflow,
    };
    document.documentElement.style.overflow = "auto";
    document.body.style.overflow = "auto";
    return () => {
      document.documentElement.style.overflow = prev.html;
      document.body.style.overflow = prev.body;
    };
  }, []);

  if (isMobile) return null;

  return (
    <header className="fixed max-w-[944px] mx-auto top-0 left-0 right-0 z-50 flex items-center justify-between h-[52px] px-6 bg-white">
      <a href="/">
        <SimplizeLogo className="h-6 sm:h-7 w-auto" />
      </a>
      <nav className="flex items-center gap-2 sm:gap-6">
        <Link
          to="/terms"
          className={`text-[16px] transition-colors hover:text-[#555] font-[500] ${pathname === "/terms" ? "text-[#111827]" : "text-[#636369]"}`}
        >
          Điều khoản sử dụng
        </Link>
        <Link
          to="/privacy"
          className={`text-[16px] transition-colors hover:text-[#555] font-[500] ${pathname === "/privacy" ? "text-[#111827]" : "text-[#636369]"}`}
        >
          Chính sách bảo mật
        </Link>
      </nav>
    </header>
  );
}
